export default "__VITE_ASSET__CNcQ5k9l__"